import { EventEmitter } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FcDataCardComponent = /** @class */ (function () {
    function FcDataCardComponent(fuseTranslationLoaderService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.seeMore = false;
        this.clickSeeMore = new EventEmitter();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    return FcDataCardComponent;
}());
export { FcDataCardComponent };
